// extracted by mini-css-extract-plugin
export default {"contactList":"ContactList_contactList__UFVCg","contactItem":"ContactList_contactItem__ppNQ5","deleteBtn":"ContactList_deleteBtn__1dg25"};